import {fetchOptions} from "./api";
import {getApiKey} from "./../selectors";

export function addWindow(windowValues) {
    return {type: "ADD_WINDOW_TO_LIST", payload: windowValues};
}

export function getWindowRooms() {
    return (dispatch, getState) => dispatch({
        type: "GET_WINDOW_ROOMS",
        payload: fetchOptions(getApiKey(getState()), "GetRooms?productSuiteId=1")
    });
}

export function getWindowStyles() {
    return (dispatch, getState) => dispatch({
        type: "GET_WINDOW_STYLES",
        payload: fetchOptions(getApiKey(getState()), "GetProducts?suiteId=1")
    });
}

export function getWindowDesigns(windowStyleId) {
    return (dispatch, getState) => dispatch({
        type: "GET_WINDOW_DESIGNS",
        payload: fetchOptions(getApiKey(getState()), "GetStyles?productId=" + windowStyleId)
    });
}

export function getWindowOptions(windowStyleId, roomId) {
    return (dispatch, getState) => dispatch({
        type: "GET_WINDOW_OPTIONS",
        payload: fetchOptions(getApiKey(getState()), "GetProductOptions?productId=" + windowStyleId + "&roomId=" + roomId)
    });
}



// WEBPACK FOOTER //
// ./src/actions/window.js